import { Actions, Subjects, SystemRoles } from '@/client/users';
import { DashboardType } from '@/common/constants';
import { useAppSelector } from '@/hooks/store';
import {
  selectCurrentAccount,
  selectCurrentAccountFeatureAbility,
} from '@/store/features/account/current-account.slice';
import { selectCurrentDashboard } from '@/store/features/dashboard';
import {
  selectCurrentUser,
  selectCurrentUserFeatureAbility,
} from '@/store/features/users/current-user.slice';
import { PostHogFeatureFlags } from '@/utils/posthog';
import { PureAbility, fieldPatternMatcher } from '@casl/ability';

// Custom hook to determine feature permissions
export const useFeatureFlag = () => {
  const user = useAppSelector(selectCurrentUser);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const userAbility = useAppSelector(selectCurrentUserFeatureAbility);
  const accountAbility = useAppSelector(selectCurrentAccountFeatureAbility);
  const selectedDashboard = useAppSelector(selectCurrentDashboard);

  const canUseFeature = (feature: Subjects | PostHogFeatureFlags) => {
    if (
      user?.account?.id === currentAccount?.id ||
      selectedDashboard === DashboardType.LEARNER ||
      (user?.role?.code === SystemRoles.MULTIPLE_ACCOUNTS_ADMIN &&
        user?.account?.id !== currentAccount?.id)
    ) {
      return userAbility ? userAbility.can(Actions.READ, feature) : false;
    } else {
      return accountAbility ? accountAbility.can(Actions.READ, feature) : false;
    }
  };

  // Used to check if selected account can use the feature if the user is in system account -> Accounts
  // in this case we can not check the current user or current account ability
  const accountCanUseFeature = (
    feature: Subjects | PostHogFeatureFlags,
    featureFlagAbilities: any,
  ) => {
    const accountAbility = new PureAbility(featureFlagAbilities, {
      fieldMatcher: fieldPatternMatcher,
    });
    return accountAbility ? accountAbility.can(Actions.READ, feature) : false;
  };

  return { canUseFeature, accountCanUseFeature };
};
